import { InputProps } from 'semantic-ui-react';
import styled from 'styled-components';

import { FormInput } from 'app/theme/Form';
import { breakpoint } from 'app/theme/theme';

interface InputWithIconProps extends Omit<InputProps, 'value'> {
  inputIcon: JSX.Element;
}

const StyledFormInput = styled(FormInput)`
  position: relative;

  &&& {
    input {
      height: 4.8rem;
      padding-left: 4.5rem;
      box-shadow: 1px 1px 7px rgba(0, 0, 0, 0.16);
      margin-bottom: 0.5rem;
      border-color: ${({ theme, error }) => error && theme.palette.error};

      ${breakpoint.up.md`
        height: 5.6rem;
        font-size: 1.8rem;
        padding-left: 5.2rem;
      `};
    }
    input::placeholder {
      color: ${({ theme }) => theme.palette.gray.dustyGray};
    }
  }
`;

const Icon = styled.div<{ $isValue?: boolean }>`
  position: absolute;
  left: 1.5rem;
  top: 50%;
  transform: translateY(-40%);
  color: ${({ theme, $isValue }) => ($isValue ? theme.palette.black : theme.palette.gray.dustyGray)};
  ${breakpoint.up.md`
    left: 2rem; 
  `};
`;

export const InputWithIcon = ({ inputIcon, error, value, ...props }: InputWithIconProps): JSX.Element => (
  <StyledFormInput {...props} error={error} value={value}>
    <Icon $isValue={Boolean(value)}>{inputIcon}</Icon>
    <input />
  </StyledFormInput>
);
